import React from "react";

const getDisplayName = (name) => {
  const reg = /_[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
  return name.replace(reg, "");
};

const ErrorList = ({ results, activeResult, onSelectResult }) => {
  return (
    <div
      style={{ overflowY: "scroll", overflowX: "hidden", height: "calc(100vh - 330px)" }}
      className="panel is-link is-radiusless is-shadowless"
    >
      {results.map((result) => (
        <a
          href="/"
          className={`panel-block ${activeResult?.id === result.id ? "is-active" : ""}`}
          onClick={(event) => {
            event.preventDefault();
            onSelectResult(result);
          }}
          key={`${result.id}`}
        >
          <span className="panel-icon">
            <i className="fas fa-info-circle" aria-hidden="true" />
          </span>
          <p className={`is-size-7 has-text-weight-semibold ${activeResult?.id === result.id ? "has-text-link" : ""}`}>
            {getDisplayName(result.fileName).trim()}
          </p>
        </a>
      ))}
    </div>
  );
};

export default ErrorList;
